import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Maria R.',
    age: 34,
    city: 'Roma',
    text: 'Ho iniziato a usare queste attività con i miei due figli a casa. Incredibile come 10 minuti di queste routine riescano a calmarli prima di andare a dormire. I materiali sono bellissimi e facilissimi da seguire.'
  }, {
    name: 'Luca B.',
    age: 41,
    city: 'Milano',
    text: 'Come insegnante della scuola primaria cercavo da tempo qualcosa del genere. Le carte delle posizioni e i giochi di movimento sono diventati un appuntamento fisso nella mia classe. I bambini li adorano.'
  }, {
    name: 'Francesca T.',
    age: 29,
    city: 'Firenze',
    text: 'Non avevo nessuna esperienza con lo yoga, ma il manuale spiega tutto in modo talmente semplice che ho iniziato subito. Il diario delle emozioni è stato una vera scoperta per mia figlia.'
  }, {
    name: 'Giuseppe M.',
    age: 38,
    city: 'Napoli',
    text: 'Da quando usiamo le storie di yoga i miei bambini sono molto più sereni e riescono a concentrarsi meglio anche sui compiti. Un investimento fantastico per tutta la famiglia.'
  }, {
    name: 'Alessandra P.',
    age: 45,
    city: 'Torino',
    text: 'Lavoro come educatrice e ho consigliato questo pacchetto a tutte le mie colleghe. Le attività sono strutturate benissimo e i bonus gratuiti valgono da soli il prezzo del biglietto.'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-226">
      <div className="max-w-4xl mx-auto" data-id="element-227">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-228">
          Cosa dicono genitori e insegnanti
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-229">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 flex flex-col" data-id="element-230">
              <div className="flex text-yellow-400 mb-4" data-id="element-231">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-current" data-id="element-232" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-233">"{t.text}"</p>
              <div className="border-t border-gray-100 pt-4 mt-auto" data-id="element-234">
                <p className="font-bold text-gray-900" data-id="element-235">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-236">
                  {t.age} anni, {t.city}, Italia
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}